import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

import {
  faXmark,
  faCircleCheck,
  faCloudArrowUp,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {Consts} from "../../pages/consts";

// example from here: https://medium.com/@dprincecoder/creating-a-drag-and-drop-file-upload-component-in-react-a-step-by-step-guide-4d93b6cc21e0

const DragNDrop = ({ onFilesSelected, accept, children }) => {
  const { t: t } = useTranslation();

  const [files, setFiles] = useState([]);

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;

    if (selectedFiles?.length > 0) {
      const newFiles = Array.from(selectedFiles);
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files;

    if (droppedFiles?.length > 0) {
      const newFiles = Array.from(droppedFiles);
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };

  const handleRemoveFile = (number) => {
    setFiles((prevFiles) => prevFiles?.filter((_, i) => i !== number));
  };

  useEffect(() => {
    onFilesSelected(files);
  }, [files, onFilesSelected]);

  return (
    <div
      className="w3-container file-upload-container"
      onDrop={handleDrop}
      onDragOver={(event) => event.preventDefault()}
    >
      <div className="file-upload-drag-and-drop">
        <FontAwesomeIcon icon={faCloudArrowUp} /> <label>{children}</label>
        <input
          type={Consts.FILE}
          hidden
          id={Consts.BROWSE}
          onChange={handleFileChange}
          accept={accept}
          multiple
        />
        {files.length === 0 && (
          <label
            htmlFor={Consts.BROWSE}
            className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left"
          >
            {t("or_browse_files")}
          </label>
        )}
        {files.length > 0 && (
          <div className="w3-container">
            {files?.map((file, index) => (
              <div className="w3-container w3-border" key={index}>
                <div className="w3-display-container">
                  <label>{file.name}</label>
                  <FontAwesomeIcon
                    icon={faXmark}
                    onClick={() => handleRemoveFile(index)}
                    className="w3-btn w3-round-xlarge w3-theme-d5 w3-right"
                  />
                </div>
              </div>
            ))}
          </div>
        )}
        {files.length > 0 && (
          <div className="w3-padding-small">
            <FontAwesomeIcon
              icon={faCircleCheck}
              className="w3-margin-right w3-text-green"
            />
            <label>
              {files.length} {t("files_selected")}
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default DragNDrop;
